import { Component, inject } from '@angular/core';

import { RouterLink, Router } from '@angular/router';
import { BreadcrumbService } from '../../services/shared/breadcrumb/breadcrumb.service';
import { PageTitleService } from '../../services/shared/page-title/page-title.service';

@Component({
    selector: 'app-page-header',
    standalone: true,
    imports: [RouterLink],
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
    private breadcrumbService = inject(BreadcrumbService);
    private pageTitleService = inject(PageTitleService);
    private router = inject(Router);

    breadcrumbs = this.breadcrumbService.breadcrumbs;
    configPageTitle = this.pageTitleService.pageTitle;

    get currentPageTitle(): string {
        // First check if there's a pageTitle from the route config
        const configTitle = this.configPageTitle();
        if (configTitle) {
            return configTitle;
        }

        // Fall back to existing logic
        const url = this.router.url;

        // Map URL patterns to static section names
        if (url.includes('/tournaments/') && url.match(/\/tournaments\/[^\/]+/)) {
            return 'Tournament';
        }
        if (url.includes('/rounds/') && url.match(/\/rounds\/[^\/]+/)) {
            // Special case for rounds - show "Round X" with the round number
            const crumbs = this.breadcrumbs();
            const roundCrumb = crumbs.find(c => c.label.startsWith('Round'));
            return roundCrumb ? roundCrumb.label : 'Round';
        }
        if (url.includes('/courses/') && url.match(/\/courses\/[^\/]+/)) {
            return 'Course';
        }
        if (url.includes('/players/') && url.match(/\/players\/[^\/]+/)) {
            return 'Player';
        }
        if (url.includes('/system')) {
            return 'System';
        }

        // Fallback to breadcrumb logic for other pages
        const crumbs = this.breadcrumbs();
        if (crumbs.length === 0) return '';

        // If we're in a nested section (more than 2 breadcrumbs), show the parent section name
        if (crumbs.length >= 3) {
            return crumbs[crumbs.length - 2].label; // Parent section name
        }

        // For top-level pages, show the current page name
        return crumbs[crumbs.length - 1].label;
    }
}